<template>
  <CCardBody>
    <div v-if="!showSuccess">
      <div class="mb-3">
        <span class="font-weight-semi-bold span-click" @click="showFields()">{{ $t('manageplan.component.card.voucher.title') }}</span>
      </div>
      <div v-if="showInputVoucher">
        <CRow alignVertical="center">
          <CCol>
            <CInput
              :disabled="loadign"
              v-model="voucher"
              :placeholder="$t('manageplan.component.card.voucher.input.placeholder')"
              style="margin-bottom: 0px"
            />
          </CCol>
          <CCol sm="3">
            <CButton @click="validateVoucher()" :disabled="loadign" variant="outline" color="primary" class="py-2 px-5">{{
              $t('manageplan.component.card.voucher.button.apply')
            }}</CButton>
          </CCol>
          <CCol sm="1" class="ml-3">
            <CButton :disabled="loadign" @click="hideFields()">
              <CIcon name="cross" size="custom-size" :height="14" viewBox="0 0 32 32" />
            </CButton>
          </CCol>
        </CRow>
        <div v-if="showError" class="mt-1 text-error">{{ $t('manageplan.component.card.voucher.error.text') }}</div>
      </div>
    </div>
    <div v-else>
      <CRow class="mb-4">
        <CCol class="font-weight-bold">
          {{ $t('manageplan.component.card.voucher.success.title') }}
          {{ voucher }}
        </CCol>
        <CCol class="text-right">
          <span class="span-click text-primary" @click="removeVoucher()">{{ $t('manageplan.component.card.voucher.success.remove.button') }}</span>
        </CCol>
      </CRow>
      <CRow class="mb-4">
        <CCol xs="1" class="pl-3">
          <CIcon name="check" size="custom-size" :height="14" viewBox="0 0 32 32" />
        </CCol>
        <CCol>
          <div v-html="$t('manageplan.component.card.voucher.success.text', { value: discountValue.toFixed(2) })"></div>
        </CCol>
      </CRow>
    </div>
  </CCardBody>
</template>

<script>
import services from '@/services.js'

export default {
  data() {
    return {
      showInputVoucher: false,
      showError: false,
      showSuccess: false,
      voucher: 'ABC123',
      loadign: false,
      discountValue: 102,
    }
  },
  methods: {
    showFields() {
      this.showInputVoucher = true
      this.showError = false
      this.voucher = ''
    },
    hideFields() {
      this.showInputVoucher = false
    },
    validateVoucher() {
      this.loadign = true

      this.showError = false

      let planId = this.$store.state.backOffice.steps.selectedPlanId
      let planTierId = this.$store.state.backOffice.steps.selectedTierId
      let periodPlanTierPriceId = this.$store.state.backOffice.steps.periodPlanTierPriceId

      let data = {
        Code: this.voucher,
        PlanId: planId,
        PlanTierId: planTierId,
        PeriodPlanTierPriceId: periodPlanTierPriceId,
      }

      services
        .validateVoucher(data)
        .then((res) => {
          let planId = res.data.data.planId
          let planTierId = res.data.data.planTierId
          let periodPlanTierPriceId = res.data.data.periodPlanTierPriceId
          this.checkPlanInfo(planId, planTierId, periodPlanTierPriceId)
        })
        .catch((err) => {
          this.showError = true
          this.loadign = false
        })
    },

    checkPlanInfo(planId, planTierId, periodPlanTierPriceId) {
      services
        .getPlansInfo(planId)
        .then((res) => {
          let planTiers = res.data.data.planTiers
          let periodPlanTierPrices = res.data.data.periodPlanTierPrices

          let tier = planTiers.find((el) => el.id == planTierId)
          let period = periodPlanTierPrices.find((el) => el.id == periodPlanTierPriceId)
          this.showSuccess = true
        })
        .catch((error) => {
          this.showError = true
        })
        .finally(() => {
          this.loadign = false
        })
    },

    removeVoucher() {
      this.voucher = ''
      this.showSuccess = false
    },
  },
}
</script>
<style lang="scss">
.span-click {
  cursor: pointer;
  text-decoration-line: underline;
}
</style>
